import axiosInstance from './axiosServicesVisit';

export const exportReports = (filter) => {
  const params = new URLSearchParams();
  Object.keys(filter).forEach(key => {
    const value = filter[key];
    if (value !== undefined && value !== null && String(value).length > 0) {
      params.append(key, String(value));
    }
  });

  const queryString = params.toString();
  // axiosInstance préfixe avec /api, et le contrôleur ajoute /v1
  return axiosInstance.get(`/v1/reports/export/all?${queryString}`, {
    responseType: 'blob',
  });
};